import { clsx } from "clsx"
import type { JSX, ReactElement } from "react"
import { Children, cloneElement } from "react"
import type { ListItemProps } from "./ListItem.component"

type ListProps = {
  readonly className?: string
  readonly children:
    | ReactElement<ListItemProps>
    | ReadonlyArray<null | ReactElement<ListItemProps>>
  readonly position?: string
  readonly type?: "bullet" | "checkmark"
  readonly tag?: keyof JSX.IntrinsicElements
}

export function List({
  children,
  className,
  position,
  tag = "ul",
  type,
}: ListProps) {
  const TagComponent = tag

  const renderChildren = () =>
    Children.map(children, (child) => {
      if (child === null) {
        return null
      }
      // Only pass type prop if it's defined
      return cloneElement(child, type ? { type } : {})
    })

  return (
    <TagComponent
      className={clsx(className, "flex flex-col")}
      data-k5a-pos={position}
    >
      {renderChildren()}
    </TagComponent>
  )
}
